import axiosInstance from "utils/APIv2";

class BaseService {
  constructor() {
    this.axios = axiosInstance;
  }
}

export default BaseService;
